// hooks/useManifestIcons.js
import { useEffect, useState } from 'react';

export default function useManifestIcons() {
    const [icons, setIcons] = useState<any[]>([]);

    useEffect(() => {
        let isAlive = true;

        fetch('/manifest.json')
            .then((res) => res.json())
            .then((json) => {
                if (isAlive && Array.isArray(json.icons)) {
                    setIcons(json.icons);
                }
            })
            .catch(() => {
                /* swallow – we’ll fall back later */
            });

        return () => {
            isAlive = false;
        };
    }, []);

    return icons;       // [{src, sizes, type, purpose?}, …]
}
